const MainMenu = (($) => {
  let _els = {};

  const init = () => {
    _els.hamburger = $('.navbar .hamburger');
    _els.mainMenu = $('#wisMainMenu');
    _addListeners();
  };

  const _addListeners = () => {
    _els.mainMenu.on('show.bs.collapse', (e) => {
      _els.hamburger.addClass('is-active');
    });

    _els.mainMenu.on('hide.bs.collapse', (e) => {
      _els.hamburger.removeClass('is-active');
    });
  };

  module.exports = {
    init: init,
  };
})(jQuery);
